import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdminService } from 'src/app/core/services/admin-apis/admin.service';
import { SpotlightService } from 'src/app/core/services/spotlight.service';

@Component({
  selector: 'app-more-info',
  templateUrl: './more-info.component.html',
  styleUrls: ['./more-info.component.css']
})
export class MoreInfoComponent implements OnInit {

  premiereDetails: any;
  mobilePremiereDetails: any;
  eventid: any;
  cinejoySchedule: any;
  datePipeString: string;
  eventImage: any;
  tags: [];
  image: any;
  cinejoyFeaturedGuests: any;
  isSecondarySideNavOpen: boolean;
  mobile_image: any;
  trailerUrl: string;




  constructor(
    private spotlightService: SpotlightService,
    private route: ActivatedRoute,
    private datePipe: DatePipe,
    private adminAPI:AdminService,
    public router: Router
  
    )
   {this.eventid = route.snapshot.params.id; }

  ngOnInit(): void {

  
      const serviceCall= this.router.url.includes('archive')
      ?this.spotlightService.getPremierdeatails(this.eventid)
      :this.spotlightService.cmsGetPremierdeatails(this.eventid);

      serviceCall.subscribe(data => {      
        this.spotlightService.setIsMotionGraphicsCompleted(false);
        this.premiereDetails = data;
        this.mobilePremiereDetails = data;
        this.trailerUrl = 'https://player.vimeo.com/video/' + this.premiereDetails.trailer + '?quality=1080p';
        console.log(this.trailerUrl, "------------tailer URL-----------");
        console.log(this.mobilePremiereDetails.cinejoyFeaturedGuests,'--------Guest Data----'); 
        this.eventImage = this.premiereDetails.eventImage;
        if(this.premiereDetails.additionalMedia != null){
          alert("ERROR: Additional Media files missing for this Spotlight '"+this.premiereDetails.name+"'")
        }
              console.warn(this.eventImage);
  
        this.tags = this.premiereDetails.tags;
  
        this.image = this.premiereDetails.cinejoyFeaturedGuests.img;
  
        this.cinejoyFeaturedGuests = this.premiereDetails.cinejoyFeaturedGuests;
  
        this.mobile_image = this.premiereDetails.cinejoyFeaturedGuests.img;
  
        console.warn(this.mobile_image = this.premiereDetails.cinejoyFeaturedGuests[0].img);
        console.warn(this.premiereDetails.trailer);
      });

  }
  updateSecondarySideNavStatus($event: any): void {
    
    this.isSecondarySideNavOpen = $event;
  }

}
